export const getNumberOfFiltersApplied = (filter, keys) => {
    const hasValidFilterKeys = keys.every(filterKey => filterKey in filter.sections);
    if (!hasValidFilterKeys) {
        throw new Error(`Invalid filter keys for ${filter.type} filter.`);
    }
    return keys.reduce((total, key) => {
        return total + filter.sections[key].options.filter(option => option.selected).length;
    }, 0);
};
//# sourceMappingURL=get-number-of-filters-applied.js.map